import numeral from 'numeral';
const formatPercentage = function(value) {
  return numeral(value).format("0[.]0%");
};

export default formatPercentage;
